<template>
  <div>
    <h6 v-if="hotel != null" class="card-title mb-1">
      <span class="d-inline d-md-none">Accommodation: </span>
      {{ hotel.title }}
    </h6>
    <button
      v-if="showButton"
      class="btn btn-sm float-right"
      :class="buttonClass"
      @click="selectProduct(dayNumber, 'Hotel')"
    >
      {{ buttonCaption }}
    </button>
  </div>
</template>

<script>
import { eventBus } from '../../main.js'

export default {
  props: {
    hotel: { type: Object, default: null },
    dayNumber: { type: Number, required: true },
    readOnly: { type: Boolean, default: false }
  },
  computed: {
    showButton() {
      if (!this.readOnly) {
        if (
          (this.dayNumber === 1 && this.hotel == null) ||
          this.hotel != null
        ) {
          return true
        }
      }
      return false
    },
    buttonClass() {
      return this.hotel != null ? 'btn-warning' : 'btn-success'
    },
    buttonCaption() {
      return this.dayNumber === 1 && this.hotel == null ? 'Add Hotel' : 'Change'
    }
  },
  methods: {
    selectProduct(dayNo, productType) {
      eventBus.selectProduct(dayNo, productType)
    }
  }
}
</script>
